'use client';

import { setCookie } from "cookies-next";
import { useEffect } from "react";

export function LocaleCookiesHandler({nativeLanguage, language}: {nativeLanguage: string, language: string}) {
    useEffect(() => {
        setCookie('locale', nativeLanguage, { maxAge: 3600 * 24 * 14 });
        setCookie('language', language, { maxAge: 3600 * 24 * 14 });
    }, [nativeLanguage, language]);

    return <></>;
}